module.exports = __webpack_public_path__ + "static/newport-566dd3f9a180eb84b63498ade6c03e40.jpg";